import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { OptionDropdown, Icon } from '@oliasoft-open-source/react-ui-library';
import { disabledFieldsUpdated } from 'store/entities/time-tracker/time-tracker';
import { itemFields } from 'src/enums/time-tracker';
import translations from 'src/internationalisation/translation-map.json';
import { selectTimeTrackerLabelCofig } from 'store/entities/company-settings/selectors';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

const getTimeSectionCheckboxTestId = (label) => {
  return `time-section-${convertToKebabCase(label)}-checkbox`;
};

const getDepthSectionCheckboxTestId = (label) => {
  return `depth-section-${convertToKebabCase(label)}-checkbox`;
};

const getDefaultSectionCheckboxTestId = (label) => {
  return `default-section-${convertToKebabCase(label)}-checkbox`;
};

const EditColumns = ({ disabledFieldsUpdated, labelConfig }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState([
    { label: t(translations.timeTracker_timeHours), type: 'Heading' },
    {
      label: labelConfig?.[itemFields.AFE] || t(translations.timeTracker_afe),
      value: itemFields.AFE,
      selected: true,
      testId: getTimeSectionCheckboxTestId(labelConfig?.[itemFields.AFE] || t(translations.timeTracker_afe)),
    },
    {
      label: labelConfig?.[itemFields.ESTIMATE] || t(translations.timeTracker_estimate),
      value: itemFields.ESTIMATE,
      selected: true,
      testId: getTimeSectionCheckboxTestId(labelConfig?.[itemFields.ESTIMATE] || t(translations.timeTracker_estimate)),
    },
    {
      label: itemFields.P90,
      value: itemFields.P90,
      selected: false,
      testId: getTimeSectionCheckboxTestId(itemFields.P90),
    },
    {
      label: itemFields.NPT.toUpperCase(),
      value: itemFields.NPT,
      selected: false,
      testId: getTimeSectionCheckboxTestId(itemFields.NPT),
    },
    {
      label: itemFields.WOW.toUpperCase(),
      value: itemFields.WOW,
      selected: false,
      testId: getTimeSectionCheckboxTestId(itemFields.WOW),
    },
    {
      label: t(translations.timeTracker_actual),
      value: itemFields.ACTUAL,
      selected: true,
      testId: getTimeSectionCheckboxTestId(t(translations.timeTracker_actual)),
    },
    {
      label: t(translations.timeTracker_variance),
      value: itemFields.VARIANCE,
      selected: true,
      testId: getTimeSectionCheckboxTestId(t(translations.timeTracker_variance)),
    },
    { type: 'Divider' },
    { label: t(translations.timeTracker_depthM), type: 'Heading' },
    {
      label: t(translations.timeTracker_planned),
      value: itemFields.PLANNED_DEPTH,
      selected: true,
      testId: getDepthSectionCheckboxTestId(t(translations.timeTracker_planned)),
    },
    {
      label: t(translations.timeTracker_actual),
      value: itemFields.ACTUAL_DEPTH,
      selected: true,
      testId: getDepthSectionCheckboxTestId(t(translations.timeTracker_actual)),
    },
    { type: 'Divider' },
    {
      label: t(translations.timeTracker_startTime),
      value: itemFields.START,
      selected: true,
      testId: getDefaultSectionCheckboxTestId(t(translations.timeTracker_startTime)),
    },
    {
      label: t(translations.timeTracker_finishTime),
      value: itemFields.FINISH,
      selected: false,
      testId: getDefaultSectionCheckboxTestId(t(translations.timeTracker_finishTime)),
    },
    { type: 'Divider' },
    {
      label: 'Section',
      value: itemFields.SECTION,
      selected: false,
      testId: getDefaultSectionCheckboxTestId('Section'),
    },
    {
      label: 'Operation',
      value: itemFields.OPERATION,
      selected: false,
      testId: getDefaultSectionCheckboxTestId('Operation'),
    },
    {
      label: 'Activity',
      value: itemFields.ACTIVITY,
      selected: false,
      testId: getDefaultSectionCheckboxTestId('Activity'),
    },
  ]);

  const icon = <Icon icon="settings" size="16px" />;
  return (
    <OptionDropdown
      testId="edit-columns-dropdown"
      onChange={(e) => {
        setOptions(e.target.value);
        const disabledFields = e.target.value.filter((item) => item.selected === false).map((item) => item.value);
        disabledFieldsUpdated(disabledFields);
      }}
      options={options}
      label={icon}
      showHeader={false}
    />
  );
};

const mapStateToProps = ({ entities }) => {
  const { isAdding } = entities.timeTracker;
  const labelConfig = selectTimeTrackerLabelCofig(entities);
  return { isAdding, labelConfig };
};

const mapDispatchToProps = { disabledFieldsUpdated };
const Container = connect(mapStateToProps, mapDispatchToProps)(EditColumns);

export { Container as EditColumns };
